import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import ADDRESS_CREATE from '../mutations/ADDRESS_CREATE';

const useAddressCreate = () => {
    const [ createNewAddress ] = useMutation( ADDRESS_CREATE );

    const createAddress = async ( saveData ) => {
        try {
            const response = await createNewAddress( { variables: { input: saveData } } );
            const success = response?.data?.createAddress;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error creating address', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            createAddress         
        };
    }, [] );
};

export default useAddressCreate;
